<template>
    <z-basePage :title="'文档模板'" v-loading.fullscreen.lock="full_screenFlag">
        <div class="search-top">
            <span>模板类型</span>
            <el-select class="top-choose" v-model="search.type" clearable>
                <el-option v-for="item in taskTpl" :key="item.id" :value="item.id" :label="item.tpl_name" >
                </el-option>
            </el-select>
            <span>名称/编号</span>
            <el-input class="top-choose" v-model="search.text" placeholder="输入名称或编号"></el-input>
            
            <div class="back-btn blue shift" @click="searchDoc(1)">搜索</div>
            <div class="back-btn red" :class="{disabled:deleteList.length==0}" @click="deleteTpl">删除</div>
        </div>
        
        <div class="back-list">
            <div class="list-head choose">
                <el-checkbox v-model="allchoose" @change="checkList"></el-checkbox>

                <div>模板编号</div>
                <div>模板类型</div>
                <div>发布时间</div>
                <div>创建者</div>
                <div>模板名称</div>
                <div>操作</div>
            </div>
            <z-scrollDiv class="main">
                <el-checkbox-group v-model = "deleteList">
                    <div class="list-item choose"  v-for="item in dataList" :key="item.id">
                        <el-checkbox  @change="changeCheck" :label="item.id" :disabled="item.tpl_doc_type==1">{{ "" }}</el-checkbox>
                        <div>{{ item.code }}</div>
                        <div class="overhide" :title="item.tpl_name">{{ item.tpl_name }}</div>
                        <div>{{ item.created_at }}</div>
                        <div class="overhide" :title="item.real_name">{{ item.real_name }}</div>
                        <div class="overhide" :title="item.tpl_doc_name">{{ item.tpl_doc_name }}</div>
                        <div>
                            <a @click='downloadFile(item.id)'></a>
                        </div>
                    </div>
                </el-checkbox-group>
                <z-noData :list="dataList"></z-noData>
            </z-scrollDiv>
        </div>

        <el-pagination
            @current-change="searchDoc"
            :current-page.sync="data.current_page"
            :total="data.total"
            :page-size="data.per_page"
            layout="prev, pager, next, jumper"
        ></el-pagination>

    </z-basePage>
</template>

<script>
    import { mapState } from "vuex"

    export default {
        data(){
            return {
                full_screenFlag:false,  //全屏遮罩
                search:{
                    type:"",
                    text:"",
                },
                data:{},
                allchoose:false,  //全选
                deleteList:[],  //删除的ID列表
            }
        },
        computed:{
            ...mapState(['taskTpl']),
            dataList(){
                return this.data.list;
            },
            maxIds(){  //可选项 总数
                return  this.dataList && this.dataList.filter(item=>{
                    return item.tpl_doc_type != 1;
                }).map(item => item.id);
            },
        },

        created(){
            this.$func.getTaskTpl(true);  //拿任务模板入口
            this.getData();
        },  

        methods:{
            getData(obj){  //获取数据
                let url = `api/admin/template/list`;
                let config = {params:obj};
                this.$http.get(url,config).then(res=>{
                    if(res.status == 200){
                        this.data =  res.res_data;
                    }
                });
            },
            searchDoc(page){  //搜索
                page = page == undefined?this.data.current_page:page;
                let obj = {
                    page:page,
                    template_id:this.search.type,
                    keyword:this.search.text,
                }
                this.getData(obj);
            },

            checkList(event){ //全选
                this.deleteList = event.target.checked?[...this.maxIds]:[];
            },
            changeCheck(){  //单选
                this.allchoose = this.deleteList.length === this.maxIds.length;
            },
            deleteTpl(){
                this.full_screenFlag = true;
                let url =  `api/admin/task_tpl_doc_deleteById`;
                this.$http.delete(url,{
                    params:{
                        ids:this.deleteList.join(","),
                    }
                }).then(res=>{
                    if(res.status == 200){
                        this.successTip("删除成功");
                        this.searchDoc();
                        this.allchoose = false;
                    }
                    this.full_screenFlag = false;
                }).catch(err=>{
                    this.errorTip("删除出错");
                    this.full_screenFlag = false;
                })
            },
            downloadFile(id){
                this.$http.get(`api/clerk/tpl_doc/${id}/download`);
            }
        }
    }
</script>

<style lang="less" scoped>
	@import "~src/assets/less/backless/var.less";

    // .search-top{
    //     .back-btn{
    //         position: relative;
    //         display: inline-block;
    //         margin-left: 30px;
    //         &+.back-btn{
    //             margin-left:15px;
    //         }
    //     }
    // }

    
    .back-list{
        margin-top:10px;
        height:calc(~"100% - @{line} - @{search_m} - 10px - @{page_need}");
        // 列表高度
        .main{
            height:calc(~"100% - @{list-head}");
        }
    }
    .list-head,.list-item{
        >div:nth-of-type(1){
            width: 15%;
        }
        >div:nth-of-type(2){
            width: 15%;
        }
        >div:nth-of-type(3){
            width: 20%;
        }
        >div:nth-of-type(4){
            width: 12%;
            padding-right: 3%;
        }
        >div:nth-of-type(5){
            width: 20%;
        }
        >div:last-of-type{
            width: 10%;
            padding-left: 5%;
            height: 100%;
            a{
                display: block;
                height: 20px;
                width:20px;
                position: relative;
                top: 50%;
                transform: translateY(-50%);
                cursor: pointer;
                background:url("../../../assets/image/back-download.png") no-repeat;
                &:hover{
                    background-position-y:-20px; 
                }
                &:active{
                    background-position-y:-40px; 
                }
            }
        }
    }
</style>





// WEBPACK FOOTER //
// page-tpl.vue?343e6b91